import React, { useEffect, useState, useContext } from "react";
import Row from "../Row";
import Column from "../Column";
import jobContext from "src/context/jobContext";


import RotateRow from "../RotateRow";
import { useLocation } from "react-router-dom";

const Table11 = ({ sarparastiGheirMostagin, setSarparastiGheirMostagin, reload }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jobId = params.get("id");
  const { setGreadingScore } = useContext(jobContext)
  const [data, setData] = useState("")

  const [finallScore, setFinallScore] = useState("")
  useEffect(() => {
    const items = JSON.parse(localStorage?.data)?.[jobId]?.sarparastiGheireMostaghim;
    if (items) {
      setData(items)


      const finallScore = (+items["کارمند یا کارگر"] * 1)
        + (+items["کمک کارشناس"] * 2) + (+items["کارشناس"] * 3) +
        (+items["کارشناس ارشد"] * 4) +
        (+items["سطوح مدیریتی"] * 5)

      const allowedScore = finallScore > 15 ? 15 : finallScore
      setFinallScore(finallScore)
      setSarparastiGheirMostagin(allowedScore)
      setGreadingScore((prev) => ({ ...prev, "sarparastiGheireMostaghim": allowedScore }))
    }
  }, [reload])
  return (
    <div>
      <div className="mt-[95px]">
        <RotateRow>سرپرستی غیر مستقیم</RotateRow>
      </div>
      <div className="mt-[-113px] mb-[110px]">
        <Row type={1}>
          <Column>سطوح</Column>
          <Column>امتیاز هر نفر</Column>
          <Column>تعداد افراد تحت سرپرستی</Column>
          <Column>امتیاز کسب شده</Column>
        </Row>
        <Row>
          <Column>کارمند یا کارگر</Column>
          <Column>1 </Column>
          <Column>{data["کارمند یا کارگر"] ? +data["کارمند یا کارگر"] : 0}</Column>
          <Column>{data["کارمند یا کارگر"] ? +data["کارمند یا کارگر"] * 1 : 0}</Column>
        </Row>
        <Row>
          <Column>کمک کارشناس</Column>
          <Column>2</Column>
          <Column>{data["کمک کارشناس"] ? +data["کمک کارشناس"] : 0}</Column>
          <Column>{data["کمک کارشناس"] ? +data["کمک کارشناس"] * 2 : 0}</Column>
        </Row>
        <Row>
          <Column>کارشناس</Column>
          <Column>3</Column>
          <Column>{data["کارشناس"] ? +data["کارشناس"] : 0}</Column>
          <Column>{data["کارشناس"] ? +data["کارشناس"] * 3 : 0}</Column>
        </Row>
        <Row>
          <Column>کارشناس ارشد</Column>
          <Column>4</Column>
          <Column>{data["کارشناس ارشد"] ? +data["کارشناس ارشد"] : 0}</Column>
          <Column>{data["کارشناس ارشد"] ? +data["کارشناس ارشد"] * 4 : 0}</Column>
        </Row>
        <Row>
          <Column>سطوح مدیریتی</Column>
          <Column>5</Column>
          <Column>{data["سطوح مدیریتی"] ? +data["سطوح مدیریتی"] : 0}</Column>
          <Column>{data["سطوح مدیریتی"] ? +data["سطوح مدیریتی"] * 5 : 0}</Column>
        </Row>
        <Row type={2}>
          <Column size={4} h={1}>
            {" "}
            حداکثر امتیاز عامل : 15
          </Column>
          <Column h={1}>امتیاز مکتسبه :{finallScore}</Column>
          <Column h={1}> امتیاز اعمال شده: {sarparastiGheirMostagin}</Column>
          <Column isActive={true} size={3} h={1}>
            {sarparastiGheirMostagin}
          </Column>
        </Row>
      </div>
    </div>
  );
};

export default Table11;
